import axios from 'axios';

const baseUrl = process.env.VUE_APP_BASE_API; 
const reqpost = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl+url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
export {
    reqpost,
}